import { render } from "./LRPChart.vue?vue&type=template&id=4fc61368&scoped=true"
import script from "./LRPChart.vue?vue&type=script&lang=js"
export * from "./LRPChart.vue?vue&type=script&lang=js"

import "./LRPChart.vue?vue&type=style&index=0&id=4fc61368&scoped=true&lang=css"

import exportComponent from "C:\\BT5DT1\\REPORT-WEB\\client\\databook\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fc61368"]])

export default __exports__